import * as React from "react";
import { IControlSchema } from "../../Controls";
import { IDispatcher } from "../extensions/Dispatcher";

interface TotalHeaderSchema extends IControlSchema{
  elements: Array<String>
}

interface Props {
  schema: TotalHeaderSchema,
  dispatcher: IDispatcher;
  values: Array<{
    controlid: string,
    value: any
  }>;
}

class TotalHeader extends React.Component<Props>{
  render(){
    const { values, schema: { title, elements} } = this.props;
    let total = 0;

    for(let control of values) {
      for(let el of elements){
        if(control.controlid.indexOf(el as string) === 0){
          total += parseFloat(control.value);
        }
      }
    }

    return (
      <div className="text-right">
        <h3>{title.ru} {total.toFixed(2)}</h3>
      </div>
    )
  }
}

export function createTotalHeader(schema: IControlSchema, dispatcher: IDispatcher = null, values: any){
  return <TotalHeader
      schema={schema as TotalHeaderSchema}
      dispatcher={dispatcher}
      values={values}
    />
}
